import { render, staticRenderFns } from "./QueueRow.vue?vue&type=template&id=813dcaf2&"
import script from "./QueueRow.vue?vue&type=script&lang=ts&"
export * from "./QueueRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports